import template from './AuthForm.html';
import SocLogin from './SocLogin.js';
import events from '../lib/events';

export default {
	template,
	props: ['value', 'init-mode'],
	components: {
		'soc-login': SocLogin
	},
	data() {
		return {
			mode: 'login',
			prevMode: null,

			email: '',
			password: '',

			regUsername: '',
			regEmail: '',
			regPassword: '',
			regConfirm: '',

			remindEmail: '',

			newPassword: '',
			newPasswordConfirm: '',

			isLoading: false,
			loginErrors: [],

			logEmailError: null,
			logPassError: null,

			regErrors: {
				general: null,
				email: null,
				name: null,
				password: null,
				confirm: null,
			},
			
			newPassError: '',
			newPassConfirmError: '',

			defaultLoginError: 'Wrong login or password',
			defaultRegisterError: 'An error occurred'
		};
	},
	methods: {
		setMode(mode) {
			this.loginErrors = [];
			this.prevMode = this.mode;
			this.mode = mode;
			this.$emit('modechanged', {mode});
		},
		onSubmit() {
			if (this.mode === 'login') {
				this.tryLogin();
			} else if (this.mode === 'register') {
				this.tryRegister();
			} else if (this.mode === 'forgot') {
				this.sendRestoreMail();
			} else if (this.mode === 'restore') {
				this.tryRestoreAccount();
			}
		},
		async tryLogin() {
			this.logPassError = this.logEmailError = null;
			if (!this.email) {
				this.logEmailError = this.ii('E_MAIL_IS_REQUIRED');
			}
			if (!this.password) {
				this.logPassError = this.ii('PASSWORD_IS_REQUIRED');
			}
			if (this.logEmailError || this.logPassError) return;

			this.isLoading = true;
			let res = await this.http.post('Auth.login', this.email, this.password);
			this.isLoading = false;

			if (res.err) {
				this.logEmailError = this.ii('WRONG_LOGIN_OR_PASSWORD');
			} else {
				this.emitAuth('login');
			}
		},
		async tryRegister() {
			this.regErrors = {};
			if (!this.regEmail || !this.regUsername || !this.regPassword || !this.regConfirm) {
				this.regErrors.general = 'PLEASE_FILL_ALL_THE_FIELDS';
				return;
			}

			this.isLoading = true;

			let res = await this.http.post('Auth.register', {
				email: this.regEmail,
				name: this.regUsername,
				password: this.regPassword,
				confirm: this.regConfirm
			});

			this.isLoading = false;

			if (res.err) {
				this.regErrors[res.err.field] = res.err.msg;
			} else {
				this.emitAuth('register');
			}
		},
		async sendRestoreMail() {
			this.isLoading = true;
			await this.http.post('Auth.sendRestoreMail', this.remindEmail);
			this.isLoading = false;
			this.alert(this.ii('PLEASE_CHECK_YOUR_INBOX'));
		},
		async tryRestoreAccount() {
			this.newPassError = this.newPassConfirmError = '';
			
			if (!this.newPassword) {
				this.newPassError = this.ii('PLEASE_ENTER_NEW_PASSWORD');
				return;
			}
			if (!this.newPasswordConfirm) {
				this.newPassConfirmError = this.ii('PLEASE_ENTER_PASSWORD_CONFIRMATION');
				return;
			}
			if (this.newPasswordConfirm !== this.newPassword) {
				this.newPassConfirmError = this.ii('INVALID_CONFIRMATION');
				return;
			}
			
			let p = this.$route.params;
			try {
				this.isLoading = true;
				let res = await this.http.post('Auth.restoreAccount', p.email, p.expire, p.hash, this.newPassword);
				this.isLoading = false;
			} catch (err) {
				this.newPassError = this.ii(err.message);
				return;
			}
			
			await this.alert(this.ii('PASSWORD_CHANGED_SUCCESSFULLY'));
			this.mode = 'login';
		},
		onSocLoginClose() {
			this.emitAuth('social');
		},
		emitAuth(type) {
			this.$emit('auth', { type });
			this.events.emit('auth', { type });
		}
	},
	mounted() {
		if (this.initMode) {
			this.setMode(this.initMode);
		}
	}
}